import { Toast } from "primereact/toast";
import { useRef, useState } from "react";

import { ICompanyMast } from "../../models/CompanyMast";
import { EmptyRole } from "./EmptyRole";
import { Form } from "./Form";
import { Table } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: ICompanyMast
}

export const RoleMast = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyRole, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyRole, open: false })
    };


    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
